
export type AppearancePreference = 'system' | 'dark' | 'light';
export type EffectiveTheme = 'dark' | 'light';

export interface IGlobalContext {
    offlineMode: boolean;
    /** На устройстве есть хотя бы один скачанный трек library_music (native). */
    hasOfflineLibraryMusic: boolean;
    prevRoute?: string;
    isManager: boolean;
    isMobile: boolean;
    musicBeta: boolean;
    videoBeta: boolean;
    showMenuNotification: boolean;
    isLoading: boolean;
    syncVideoGuide: boolean;
    medicalBookExpired: boolean;
    /** Выбор темы: system | dark | light */
    appearance: AppearancePreference;
    /** Фактическая тема после resolve (system → OS). */
    effectiveTheme: EffectiveTheme;
    /** Открыто блокирующее окно согласия — не делать router.replace из offline timeout. */
    blockingConsentOpen: boolean;
}

export class GlobalContext implements IGlobalContext {
    offlineMode = false;
    hasOfflineLibraryMusic = false;
    prevRoute = '';
    isManager = false;
    isMobile = false;
    musicBeta = false;
    videoBeta = false;
    showMenuNotification = false;
    isLoading = false;
    syncVideoGuide = false;
    medicalBookExpired = false;
    appearance: AppearancePreference = 'dark';
    effectiveTheme: EffectiveTheme = 'dark';
    blockingConsentOpen = false;

    constructor() {
    }
}
